export const categories = [
  { slug: 'danmei', name: '耽美', icon: 'ri-heart-line', description: '唯美动人的耽美漫画世界' },
  { slug: 'chunai', name: '纯爱', icon: 'ri-heart-2-line', description: '甜蜜温馨的纯爱故事' },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line', description: '奇幻瑰丽的玄幻冒险' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line', description: '现代都市的情感纠葛' },
  { slug: 'gufeng', name: '古风', icon: 'ri-landscape-line', description: '古韵悠长的国风漫画' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松欢乐的搞笑日常' },
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '激情澎湃的热血战斗' },
  { slug: 'baihe', name: '百合', icon: 'ri-women-line', description: '细腻温柔的百合情缘' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-star-line', description: '天马行空的奇幻世界' },
];

export const comics = [
  {
    id: 1,
    title: '天官赐福',
    author: '墨香铜臭',
    category: 'danmei',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20manga%20cover%20art%20featuring%20two%20elegant%20male%20characters%20in%20flowing%20robes%2C%20ethereal%20atmosphere%2C%20soft%20warm%20lighting%2C%20traditional%20Chinese%20ink%20painting%20style%2C%20delicate%20linework%2C%20dreamy%20color%20palette%2C%20romantic%20undertones%2C%20cherry%20blossom%20petals%20falling&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '八百年前，谢怜飞升成仙，成为万人敬仰的武神。然而一场变故令他跌落神坛，从此沦为三界笑柄。八百年后，他第三次飞升，却遇到了那个神秘又危险的红衣少年——花城。一段跨越八百年的羁绊，就此展开。',
    status: '连载中',
    rating: 9.8,
    views: 12800000,
    chapters: 246,
    tags: ['古风', '仙侠', '虐恋', 'HE'],
    updatedAt: '2026-08-03',
  },
  {
    id: 2,
    title: '魔道祖师',
    author: '墨香铜臭',
    category: 'danmei',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20Chinese%20manga%20cover%20with%20a%20mysterious%20man%20in%20black%20robes%20holding%20a%20flute%2C%20surrounded%20by%20ghostly%20spirits%2C%20moonlit%20night%20scene%2C%20traditional%20Chinese%20art%20style%2C%20dramatic%20shadows%2C%20elegant%20composition&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '魏无羡，云梦江氏的大弟子，因修鬼道被仙门百家围剿而死。十三年后，莫玄羽献舍让他重归人间，与昔日同窗蓝忘机重逢，两人一同揭开当年阴谋的真相。',
    status: '已完结',
    rating: 9.9,
    views: 25600000,
    chapters: 320,
    tags: ['仙侠', '重生', '虐恋', 'HE'],
    updatedAt: '2026-07-28',
  },
  {
    id: 3,
    title: '撒野',
    author: '巫哲',
    category: 'dushi',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20urban%20slice%20of%20life%20manga%20cover%20showing%20two%20young%20men%20on%20a%20city%20rooftop%20at%20sunset%2C%20warm%20golden%20hour%20light%2C%20casual%20clothing%2C%20intimate%20atmosphere%2C%20soft%20watercolor%20style%2C%20emotional%20and%20tender%20mood&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '蒋丞，一个从小在重点学校长大的学霸，因为家庭变故被送到了一座陌生的小城市。在这里，他遇到了叛逆不羁却内心温柔的顾飞。两个截然不同的少年，在彼此的陪伴下找到了希望和方向。',
    status: '已完结',
    rating: 9.7,
    views: 18900000,
    chapters: 285,
    tags: ['校园', '成长', '治愈', 'HE'],
    updatedAt: '2026-08-01',
  },
  {
    id: 4,
    title: '全球高考',
    author: '木苏里',
    category: 'xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20manga%20cover%20with%20mysterious%20exam%20hall%20setting%2C%20two%20male%20characters%20facing%20each%20other%2C%20tense%20atmosphere%2C%20dark%20academia%20aesthetic%2C%20clock%20motif%2C%20dramatic%20lighting%2C%20modern%20clean%20art%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '一场诡异的全球考试将所有人卷入了一个残酷的生存游戏。游惑与秦究在考场中相遇，两个顶尖考生之间的较量与合作，将揭开考试背后惊天秘密。',
    status: '连载中',
    rating: 9.6,
    views: 15200000,
    chapters: 198,
    tags: ['无限流', '强强', '烧脑', 'HE'],
    updatedAt: '2026-08-02',
  },
  {
    id: 5,
    title: '将进酒',
    author: '唐酒卿',
    category: 'gufeng',
    cover: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20palace%20drama%20manga%20cover%2C%20two%20noblemen%20in%20elaborate%20traditional%20hanfu%2C%20golden%20palace%20interior%20background%2C%20opulent%20details%2C%20warm%20candlelight%2C%20classical%20Chinese%20painting%20aesthetic%2C%20rich%20red%20and%20gold%20tones&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '沈泽川，前朝遗孤，被软禁深宫十三年。萧驰野，离北王的独子，桀骜不驯。两人在波谲云诡的朝堂斗争中从敌对到联手，在血与火中杀出一条生路。',
    status: '连载中',
    rating: 9.8,
    views: 21300000,
    chapters: 410,
    tags: ['权谋', '古风', '强强', 'HE'],
    updatedAt: '2026-08-04',
  },
  {
    id: 6,
    title: '某某',
    author: '木苏里',
    category: 'chunai',
    cover: 'https://readdy.ai/api/search-image?query=High%20school%20romance%20manga%20cover%20with%20two%20teenage%20boys%20in%20school%20uniforms%20under%20cherry%20blossom%20trees%2C%20spring%20sunlight%2C%20youthful%20and%20fresh%20atmosphere%2C%20soft%20pastel%20colors%2C%20anime%20style%20illustration%2C%20innocent%20and%20sweet%20mood&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '江添和盛望，一个是冷漠疏离的学神，一个是阳光开朗的转学生。两人因为家庭重组而住到了同一个屋檐下，从互看不顺眼到彼此依赖，青春的故事就此展开。',
    status: '已完结',
    rating: 9.5,
    views: 14500000,
    chapters: 230,
    tags: ['校园', '伪兄弟', '甜文', 'HE'],
    updatedAt: '2026-07-20',
  },
  {
    id: 7,
    title: '破云',
    author: '淮上',
    category: 'xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20manga%20cover%20featuring%20a%20detective%20and%20his%20partner%20in%20a%20rainy%20city%20alley%2C%20noir%20atmosphere%2C%20dark%20blue%20and%20gray%20tones%2C%20dramatic%20lighting%2C%20mysterious%20mood%2C%20modern%20police%20procedural%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '三年前，缉毒警江停在一次行动中失踪，被认定为牺牲。三年后，刑侦队长严峫在追查一起毒品案时，意外发现江停还活着。两人联手，一步步揭开了隐藏在黑暗中的巨大阴谋。',
    status: '已完结',
    rating: 9.7,
    views: 17600000,
    chapters: 268,
    tags: ['刑侦', '强强', '悬疑', 'HE'],
    updatedAt: '2026-07-15',
  },
  {
    id: 8,
    title: '二哈和他的白猫师尊',
    author: '肉包不吃肉',
    category: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20cultivation%20manga%20cover%20with%20a%20master%20in%20white%20robes%20and%20his%20disciple%2C%20floating%20mountains%20in%20background%2C%20magical%20glowing%20effects%2C%20ethereal%20clouds%2C%20traditional%20Chinese%20xianxia%20aesthetic%2C%20elegant%20brushwork%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '墨燃重生了。上一世，他是修真界人人得而诛之的踏仙君，亲手害死了自己的师尊楚晚宁。这一世，他发誓要护师尊周全。然而随着真相一步步揭开，他发现前世的一切并非表面那么简单。',
    status: '连载中',
    rating: 9.6,
    views: 20300000,
    chapters: 365,
    tags: ['仙侠', '重生', '师徒', '虐恋'],
    updatedAt: '2026-08-03',
  },
  {
    id: 9,
    title: '伪装学渣',
    author: '木瓜黄',
    category: 'chunai',
    cover: 'https://readdy.ai/api/search-image?query=School%20life%20comedy%20manga%20cover%20showing%20two%20high%20school%20boys%20in%20classroom%2C%20one%20sleeping%20on%20desk%20and%20other%20looking%20amused%2C%20bright%20sunny%20classroom%2C%20lighthearted%20and%20funny%20vibe%2C%20clean%20anime%20art%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '贺朝和谢俞，一个是从良的校霸，一个是隐藏的学霸。两人被分到同一个班，开始了彼此"伪装"的高中生活。当两个都在装学渣的人碰在一起，会发生什么有趣的故事呢？',
    status: '已完结',
    rating: 9.4,
    views: 11800000,
    chapters: 175,
    tags: ['校园', '甜文', '搞笑', 'HE'],
    updatedAt: '2026-06-30',
  },
  {
    id: 10,
    title: '铜钱龛世',
    author: '木苏里',
    category: 'gufeng',
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20supernatural%20manga%20cover%2C%20a%20scholar%20and%20a%20mysterious%20figure%20in%20a%20foggy%20bamboo%20forest%2C%20ancient%20coins%20floating%2C%20ghostly%20atmosphere%2C%20muted%20earth%20tones%2C%20traditional%20ink%20wash%20painting%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '薛闲，一个半死不活的风水先生，为了活命不得不替人消灾解难。在一次委托中，他遇到了一位神秘又强大的存在——玄悯。两人结伴同行，游走于阴阳两界，揭开一桩桩诡异事件背后的真相。',
    status: '已完结',
    rating: 9.5,
    views: 9800000,
    chapters: 195,
    tags: ['灵异', '古风', '强强', 'HE'],
    updatedAt: '2026-07-10',
  },
  {
    id: 11,
    title: '死亡万花筒',
    author: '西子绪',
    category: 'xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=Horror%20survival%20manga%20cover%20with%20kaleidoscope%20motif%2C%20two%20characters%20in%20a%20distorted%20mirror%20world%2C%20eerie%20and%20beautiful%20visuals%2C%20dark%20purple%20and%20silver%20color%20scheme%2C%20surreal%20atmosphere%2C%20psychological%20thriller%20aesthetic&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '林秋石发现自己被卷入了一场诡异的游戏——门的世界。每一扇门后都是一个恐怖副本，只有通关才能活下来。在这个残酷的游戏中，他遇到了神秘又强大的阮南烛，两人并肩作战，试图找到逃离的方法。',
    status: '已完结',
    rating: 9.8,
    views: 23100000,
    chapters: 312,
    tags: ['无限流', '恐怖', '强强', 'HE'],
    updatedAt: '2026-08-01',
  },
  {
    id: 12,
    title: '我喜欢你的信息素',
    author: '引路星',
    category: 'chunai',
    cover: 'https://readdy.ai/api/search-image?query=ABO%20genre%20school%20romance%20manga%20cover%2C%20two%20handsome%20male%20students%20close%20together%20in%20school%20hallway%2C%20pheromone%20visualization%20as%20sparkles%2C%20warm%20romantic%20lighting%2C%20modern%20clean%20anime%20style%2C%20soft%20pink%20and%20gold%20accents&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '段嘉衍是一个普通的Beta——至少他是这么认为的。直到某天，他被班上那个冷冰冰的Alpha班长路星辞的信息素引发了发情期，才意识到自己其实是个Omega。从此，他的校园生活彻底改变了。',
    status: '已完结',
    rating: 9.3,
    views: 10500000,
    chapters: 160,
    tags: ['ABO', '校园', '甜文', 'HE'],
    updatedAt: '2026-07-05',
  },
];

export const heroBanners = [
  {
    id: 1,
    comicId: 1,
    title: '天官赐福 - 现象级古风巨作',
    subtitle: '跨越八百年的倾世之恋，感动千万读者',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20landscape%20with%20floating%20celestial%20palace%2C%20cherry%20blossom%20trees%2C%20two%20silhouettes%20of%20elegant%20figures%20in%20flowing%20robes%2C%20golden%20and%20crimson%20color%20palette%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20ethereal%20atmosphere%2C%20dreamy%20clouds%2C%20soft%20diffused%20lighting%2C%20romantic%20epic%20scale&width=1600&height=700&seq=hero-banner-01&orientation=landscape',
  },
  {
    id: 2,
    comicId: 2,
    title: '魔道祖师 - 经典永不过时',
    subtitle: '夷陵老祖归来，再掀仙侠风云',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20mountain%20landscape%20at%20night%2C%20moonlit%20sky%2C%20floating%20spiritual%20energy%2C%20ancient%20Chinese%20temple%20ruins%2C%20mysterious%20atmosphere%2C%20ink%20wash%20painting%20style%2C%20silver%20and%20navy%20color%20scheme%2C%20dramatic%20composition&width=1600&height=700&seq=hero-banner-02&orientation=landscape',
  },
  {
    id: 3,
    comicId: 5,
    title: '将进酒 - 朝堂权谋巅峰之作',
    subtitle: '古风权谋天花板，步步惊心扣人心弦',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20grand%20throne%20room%2C%20golden%20light%20streaming%20through%20windows%2C%20ornate%20architecture%2C%20two%20figures%20in%20elaborate%20robes%2C%20dramatic%20composition%2C%20rich%20gold%20and%20deep%20red%20tones%2C%20traditional%20Chinese%20painting%20style&width=1600&height=700&seq=hero-banner-03&orientation=landscape',
  },
];

export const hotRanking = [
  { rank: 1, comicId: 2, title: '魔道祖师', views: '2560万' },
  { rank: 2, comicId: 11, title: '死亡万花筒', views: '2310万' },
  { rank: 3, comicId: 5, title: '将进酒', views: '2130万' },
  { rank: 4, comicId: 8, title: '二哈和他的白猫师尊', views: '2030万' },
  { rank: 5, comicId: 3, title: '撒野', views: '1890万' },
  { rank: 6, comicId: 7, title: '破云', views: '1760万' },
  { rank: 7, comicId: 4, title: '全球高考', views: '1520万' },
  { rank: 8, comicId: 6, title: '某某', views: '1450万' },
  { rank: 9, comicId: 1, title: '天官赐福', views: '1280万' },
  { rank: 10, comicId: 9, title: '伪装学渣', views: '1180万' },
];

export const latestUpdates = [
  { comicId: 5, title: '将进酒', chapter: '第410话 江山如画', time: '2小时前' },
  { comicId: 1, title: '天官赐福', chapter: '第246话 花灯之夜', time: '3小时前' },
  { comicId: 8, title: '二哈和他的白猫师尊', chapter: '第365话 真相大白', time: '5小时前' },
  { comicId: 4, title: '全球高考', chapter: '第198话 最终考场', time: '6小时前' },
  { comicId: 11, title: '死亡万花筒', chapter: '第312话 万象归元', time: '8小时前' },
  { comicId: 3, title: '撒野', chapter: '第285话 未来可期', time: '12小时前' },
  { comicId: 7, title: '破云', chapter: '第268话 破晓时分', time: '1天前' },
  { comicId: 2, title: '魔道祖师', chapter: '第320话 终章·忘羡', time: '2天前' },
];

export const testimonials = [
  {
    id: 1,
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20portrait%2C%20soft%20smile%2C%20pastel%20colors%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
    comment: '耽耽漫画真的是我见过最好用的漫画平台！下拉式阅读太舒服了，不用一直翻页，一口气能看几十话！漫画资源也超全，想看的几乎都能找到。',
    rating: 5,
  },
  {
    id: 2,
    name: '星辰',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20boy%20avatar%20portrait%2C%20cool%20expression%2C%20short%20dark%20hair%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    comment: '自从发现了耽耽漫画，就再也没有用过其他平台。分类很清楚，找漫画很方便。而且更新速度真的快，热门作品基本同步更新，追漫体验一级棒！',
    rating: 5,
  },
  {
    id: 3,
    name: '薄荷糖',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20portrait%2C%20glasses%2C%20gentle%20smile%2C%20long%20hair%2C%20soft%20colors%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    comment: '页面设计简洁好看，没有乱七八糟的广告，阅读体验特别纯净。书架上收藏了五十多部漫画了，每天都要上来看看有没有更新，已经是生活中不可或缺的一部分了！',
    rating: 5,
  },
];